import type { VcsConnection } from 'components/organizations/vcs/vcs-connection-modal/vcs-connection-modal-picker';
import type { AuthenticationType } from './use-connection-modal-access-card-form.hook';
import type { VcsApi } from '@env0/vcs-service/api';

export function getAvailableAuthenticationTypes(vcsConnection: VcsConnection): AuthenticationType[] {
  switch (vcsConnection.type) {
    case 'VcsTester':
      return ['VcsAgent', 'OAuth', 'AccessToken'];
    case 'GitHub':
      return ['OAuth'];
    case 'GitLab':
      return ['OAuth', 'AccessToken'];
    case 'BitBucket':
    case 'AzureDevOps':
      return ['OAuth'];
    case 'BitBucketServer':
    case 'GitHubEnterprise':
    case 'GitLabEnterprise':
      return ['VcsAgent'];
    default:
      return [];
  }
}

export function getSupportedConnectionTypes(vcsType: VcsApi.VcsType): VcsApi.ConnectionType[] | undefined {
  switch (vcsType) {
    case 'VcsTester':
      return ['DeploymentPipeline', 'CodeWrite'];
    case 'GitHub':
      return ['DeploymentPipeline', 'CodeWrite'];
    case 'GitLab':
    case 'BitBucket':
    case 'AzureDevOps':
      return ['DeploymentPipeline'];
    case 'BitBucketServer':
    case 'GitLabEnterprise':
      return ['DeploymentPipeline'];
    case 'GitHubEnterprise':
      return ['DeploymentPipeline', 'CodeWrite'];
    default:
      return;
  }
}
